var constants = require('../constants');

var UpdateSurvey = (function() {

    var _updateSurveyIndex = function(index) {
        return {
            type: constants.UPDATE_SURVEY_INDEX,
            currentSurveyIndex: index
        };
    }

    return {
        updateSurveyIndex: _updateSurveyIndex
    }
})();

module.exports = UpdateSurvey;


// WEBPACK FOOTER //
// ./src/common/modules/survey/actions/surveys-update-survey.js